import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppointmentsList } from 'components/Bookings2/List/AppointmentsList';
import moment from 'moment-timezone';
import { FunctionComponent } from 'react';
import { createPortal } from 'react-dom';
import styles from './DaycareBookingsModal.module.scss';

interface DaycareBookingsModalProps {
    date: string;
    onClose: () => void;
}

export const DaycareBookingsModal: FunctionComponent<DaycareBookingsModalProps> = props => {
    const formattedDate = moment(props.date, 'YYYY-MM-DD').format('dddd, MMMM D, YYYY');

    return createPortal(
        <div
            className={styles.backdrop}
            role="presentation"
            onMouseDown={event => event.target === event.currentTarget && props.onClose()}
        >
            <section
                aria-labelledby="daycare-bookings-modal-title"
                aria-modal="true"
                className={styles.modal}
                role="dialog"
            >
                <header className={styles.header}>
                    <h2
                        className={styles.title}
                        id="daycare-bookings-modal-title"
                    >
                        Daycare bookings — {formattedDate}
                    </h2>
                    <button
                        aria-label="Close daycare bookings"
                        className={styles.closeButton}
                        type="button"
                        onClick={props.onClose}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </header>
                <div className={styles.content}>
                    <AppointmentsList
                        key={props.date}
                        className={styles.list}
                        fixedDate={props.date}
                        listType="daycare"
                        overlayZIndex={10110}
                        scrollableContainerId="calendar-daycare-bookings-list"
                    />
                </div>
            </section>
        </div>,
        document.body
    );
};

export default DaycareBookingsModal;
